import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ModalConfirmation } from '@/lib/v2/examples';

import {
  atomRefetchAllData,
  atomTotalSelectedRows,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import { atomToggleDeleteActionsModal } from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { useCampaignActionsStateContext } from '@/modules/CampaignsModule/contexts/CampaignActionsContext';
import { useCampaignActions } from '@/modules/CampaignsModule/hooks/useCampaignActions';

const DeleteActions = () => {
  const { t } = useTranslation();
  const [toggleDeleteActionsModal, setToggleDeleteActionsModal] = useAtom(
    atomToggleDeleteActionsModal
  );

  const { id } = useParams();
  const { filterBy, orderBy, pageIndex, pageSize } = useCampaignActionsStateContext();
  const { deleteAction, loading } = useCampaignActions({
    campaignID: Number(id),
    campaignActionsStateContext: { filterBy, orderBy, pageIndex, pageSize },
  });
  const setRefetchAllData = useSetAtom(atomRefetchAllData);
  const totalSelectedRows = useAtomValue(atomTotalSelectedRows);

  const handleConfirm = useCallback(async () => {
    await deleteAction();
    setToggleDeleteActionsModal(false);
    setRefetchAllData(true);
  }, [setRefetchAllData, setToggleDeleteActionsModal, deleteAction]);

  return (
    <ModalConfirmation
      isLoading={loading}
      isOpen={toggleDeleteActionsModal}
      textCancelButton={t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.cancelButton')}
      textConfirmButton={t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.successButton')}
      title={
        totalSelectedRows > 1
          ? t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.MULTIPLE.title')
          : t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.SINGLE.title')
      }
      onClose={setToggleDeleteActionsModal}
      onConfirmButton={handleConfirm}
    />
  );
};

export default DeleteActions;
